var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMicrosoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 12.1876H26.0001V0.812765C26.0001 0.363946 25.6361 0 25.1875 0H13.8125V12.1876Z",
    fill: "#5ACF5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1877 12.1876V0H0.812684C0.363953 0 0 0.363946 0 0.812765V12.1876H12.1877Z",
    fill: "#F84437"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1877 13.8125H0V25.1875C0 25.6358 0.363953 26 0.812684 26H12.1877V13.8125Z",
    fill: "#2299F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 13.8125V26H25.1875C25.6361 26 26.0001 25.6358 26.0001 25.1875V13.8125H13.8125Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMicrosoft);
export default __webpack_public_path__ + "static/media/logo-microsoft.5c015261.svg";
export { ForwardRef as ReactComponent };